import { useState } from 'react';

import Link from '@anwb/poncho/components/link';
import Login from '@anwb/poncho/components/login';
import Panel from '@anwb/poncho/components/panel';
import Typography from '@anwb/poncho/components/typography';
import { trackEvent } from 'utils/trackEvent';

export type SignInPanelProps = {
	isLoggedIn: boolean;
	setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SignInPanel = ({ isLoggedIn, setIsLoggedIn }: SignInPanelProps) => {
	const [showModal, setShowModal] = useState(false);

	if (isLoggedIn) {
		return null;
	}

	return (
		<>
			<Panel hasOuterSpacing={false} variant="featured">
				<Panel.Content>
					<Typography variant="component-title">Sneller door het formulier</Typography>
					<Typography>Door in te loggen kunnen we de bekende gegevens van jou invullen</Typography>
					<Link
						dataTest="sign-in-panel-link"
						onClick={() => {
							setShowModal(true);
							trackEvent({
								event: 'user_interaction',
								type: 'form',
								component: 'link',
								action: 'click',
								actionValue: 'inloggen',
							});
						}}
					>
						Inloggen
					</Link>
				</Panel.Content>
			</Panel>
			{showModal && (
				<Login onLogin={() => setIsLoggedIn(true)} onClose={() => setShowModal(false)} />
			)}
		</>
	);
};
